import CreateNewSecureLinkButton from './CreateNewSecureLinkButton.component';

export default CreateNewSecureLinkButton;